import { createRouter, createWebHashHistory } from 'vue-router'
import qs from 'qs';

import appSmartCatalog from '../pages/app-smart-catalog'
import appSmartCatalogLayout from '../pages/app-smart-catalog-layout'

export default new createRouter({
  history: createWebHashHistory(),
  parseQuery(query) {
    return qs.parse(query);
  },
  stringifyQuery(query) {
    const result = qs.stringify(query);

    return result || '';
  },
  routes: [
    {
      path: '/smart-catalog/',
      name: 'smart-catalog-layout',
      component: appSmartCatalogLayout,
      children: [
        {
          path: ':domain/:_id',
          name: 'smart-catalog',
          component: appSmartCatalog,
        },

      ]
    }
  ]
})
